import { OrderAnalyticsApiClient } from '@fourthwall/services/dist/OrderAnalyticsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useVariantsAnalyticsQuery = createQueryHook(
  OrderAnalyticsApiClient.getVariantsAnalytics,
  {
    queryKey: ['variantsAnalytics'],
  },
)
